import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

interface SkeletonProps {
    className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
    const classes = useStyles();

    return <div className={cn(classes.animated, classes.skeleton, className)} />;
};

const useStyles = makeStyles(
    {
        skeleton: {
            height: 14,
            borderRadius: 14,
            background: '#C4C4C4',
        },
        animated: {
            position: 'relative',
            overflow: 'hidden',

            '&:after': {
                content: '""',
                animation: '$waveKeyframe 1.6s linear 0.5s infinite',
                background: `linear-gradient(90deg, transparent, #40404020, transparent)`,
                position: 'absolute',
                transform: 'translateX(-100%)',
                bottom: 0,
                left: 0,
                right: 0,
                top: 0,
            },
        },
        '@keyframes waveKeyframe': {
            '0%': {
                transform: 'translateX(-100%)',
            },
            '50%': {
                transform: 'translateX(100%)',
            },
            '100%': {
                transform: 'translateX(100%)',
            },
        },
    },
    { classNamePrefix: 'skeleton' }
);

export default Skeleton;
